<template>
<div>
  <div class="docs-wrapper">
    <div class="docs-nav-bar only-on-small">
      <button class="button button-icon" @click="showApiNav = !showApiNav">
        <i class="icon">menu</i> Navigate
      </button>
      <SpinnerApiLoading/>
    </div>
    <div class="docs-container">
      <NavigationApi class="docs-nav only-on-large"/>
      <div class="docs-content">
        <div class='manual-page' v-if="isManualPage">
          <Markdown :content='content'></Markdown>
        </div>
        <div v-if="entry">
          <component :is="currentEntryComponent" :entry='entry'
                     v-if='currentEntryComponent'/>
        </div>
        <div v-if="!entry && !isManualPage">
          Unknown component {{entry}}
        </div>
      </div>
    </div>

    <div :class="{
        'docs-nav-absolute-overlay': showApiNav
      }" v-if="showApiNav" @click="showApiNav = false"/>
    <NavigationApi :class="{
        'docs-nav': true,
        'docs-nav-absolute': true,
        'docs-nav-absolute-visible': showApiNav,
        'only-on-small': true}"/>
  </div>
</div>
</template>

<script>
import DocsDetailType from '../components/docs/DocsDetailType.vue';
import DocsDetailNamespace from '../components/docs/DocsDetailNamespace.vue';
import DocsDetailClass from '../components/docs/DocsDetailClass.vue';
import { Docs, DOCS_API_PATH } from '../utils/docs';
import NavigationApi from '../components/NavigationApi';
import Markdown from '../components/Markdown';
import { getManualPageByPath } from '../utils/manual';
import SpinnerApiLoading from '../components/SpinnerApiLoading';

export default {
  name: 'page-docs',
  data () {
    return {
      entry: null,
      targetHash: null,
      showApiNav: false
    };
  },
  watch: {
    $route (to, from) {
      this.targetHash = to.hash;
      this.updateEntry();
      this.maybeRedirectToDefault();
    },
    entry () {
      this.maybeRedirectToDefault();
    },
    path () {
      this.maybeRedirectToDefault();
    }
  },
  created () {
    this.updateEntry();
  },
  mounted () {
    this.maybeRedirectToDefault();
    this.scrollToAnchor();
  },
  updated () {
    this.scrollToAnchor();
  },
  computed: {
    currentEntryComponent () {
      if (!this.entry) return null;

      if (this.entry.kind === 'typedef' || this.entry.kind === 'constant') {
        return 'DocsDetailType';
      } else if (this.entry.kind === 'namespace') {
        return 'DocsDetailNamespace';
      } else if (this.entry.kind === 'class' ||
        this.entry.kind === 'interface') {
        return 'DocsDetailClass';
      }
      return null;
    },
    loaded () {
      return this.db != null;
    },
    db () {
      return this.$store.state.docs.db;
    },
    isManualPage () {
      return !(this.$route && this.$route.name === DOCS_API_PATH);
    },
    content: function () {
      const path = this.$route && this.$route.params && this.$route.params.path;
      const page = path ? getManualPageByPath(path) : null;
      return page ? page.data : 'Upps - this one does not exist';
    }
  },
  components: {
    SpinnerApiLoading,
    Markdown,
    NavigationApi,
    DocsDetailClass,
    DocsDetailType,
    DocsDetailNamespace
  },
  methods: {
    maybeRedirectToDefault () {
      if (this.$route && this.$route.path === '/docs') {
        this.$router.push({ name: 'docs', params: { path: 'getting_started' } });
      }
    },
    scrollToAnchor () {
      if (this.$route.hash) {
        const hash = this.$route.hash.substr(1);
        const el = document.getElementById(hash);
        if (el) {
          el.scrollIntoView();
        }
      }
    },
    updateEntry () {
      const currentPath = this.$router.history.current;

      if (currentPath.name !== DOCS_API_PATH) {
        this.entry = null;
        return;
      }

      const longname = currentPath.params.path;
      const result = Docs.find({ longname: longname })[0];
      if (result) {
        if (result.kind === 'function' || result.kind === 'member') {
          // If the entry is a function or member, we will redirect to its parent

          this.$router.replace({
            path: `/${DOCS_API_PATH}/${result.memberof}`,
            hash: result.name
          });
          return;
        }
      }
      this.entry = result;
    }
  }
};
</script>
